<section id="main-section" style="margin-left: 0px;" class="pd-t40 pd-b40 pd-l40 pd-r40 pd-sm-20 lightgrey-bg">
    <div class="mg-auto" style="height: 100%;">
        <div style="height: 82vh;">
            <iframe  #iframe width="100%" height="100%" id="hirationIframeId" [srcdoc]="hirationHTML" frameBorder="0" ></iframe>
        </div>        
    </div>
</section>


